<template>
	<div class="plug-tree">
		<div class="div">选择区域：</div>
		<div style="overflow: auto;height:calc(100% - 40px)">
			<el-tree :props="props" ref="nodeTree" :show-checkbox="true" :check-strictly="true" :highlight-current="true" :current-node-key="nodeId"  node-key="id" @node-click="nodeClick" @check="nodeCheck" :load="loadNode" lazy> </el-tree>
		</div>
	</div>
</template>

<script>
	import publicAPI from '../../api-path/public-api'
	export default {
		name: "tree",
		props: {
			switchVal: {
				type: Boolean,
				default: false
			},
			showSwitch: {
				type: Boolean,
				default: true,
			},
			title: {
				type: String,
				default: '是否查询下级',
			},
			isfirstChoice: {
				type: Boolean,
				default: true,
			},
			areaId:{
				type:String
			}
		},
		data() {
			return {
				newSwitchVal: false,
				areaTreeList:[],
				nodeId: '0',
				props: {
					label: 'name',
					key: 'id',
					children: 'areaTreeListResList',
					isLeaf: 'isLast'
				},
				nowAreaId:'',
				choosedNode:[],
				
			}
		},
		created() {
			
			if (this.switchVal) {
				this.newSwitchVal = this.switchVal === this.newSwitchVal ? this.newSwitchVal : this.switchVal
			}
		},
		
		methods: {
			loadNode(node, resolve) {
				if(!this.areaId){
					this.nowAreaId=localStorage.getItem('centerId')?localStorage.getItem('centerId'):'0';
				}else{
					this.nowAreaId=this.areaId;
				}
				let $this=this;
				if (node.level === 0) {
					let areaId= this.nowAreaId;
					$this.$http.get(publicAPI.areaListTree,{params: { id: areaId }}).then(res => {
						if (res.status==200) {
							$this.areaTreeList=res.result.areaTreeListResList;
							if(this.isfirstChoice){
								setTimeout(function () {
									$this.$nextTick(function () {
										this.nodeId=res.result.id;
										$this.$refs.nodeTree.setCurrentKey(this.nodeId)
										$this.$emit('nodeClick', res.result)
									})
								},1000)
							}
							return resolve([res.result]);
						}
					})
				}
				if (node.level ==1) {
					return resolve(this.areaTreeList);
				}
				if (node.level > 1) {
					this.loadchildnode(node, resolve);
				}
			},
			loadchildnode(node, resolve) {
				this.$http.get(publicAPI.areaListTree, {
					params: { id: node.data.id }
				}).then(res => {
					if (res.status==200) {
						return resolve(res.result.areaTreeListResList);
					}
				})
			},
			changeSwitch(e) {
				this.$emit('changeSwitch', e)
				sessionStorage.setItem('switch',e);
			},
			nodeClick(node) {
				// this.$emit('nodeClick', node);
			},
			nodeCheck(node,checked){
				if(node.id){
					let choosedNodeNow=checked.checkedKeys;
					let id=node.id;
					let parentId=node.parentId;
					let result=this.choosedNode.findIndex(item=>item.id==id);
					
					this.choosedNode.map(item=>{
						this.$refs.nodeTree.setChecked(item,false)
					})
					if(result==-1){
						let result1=this.choosedNode.findIndex(item=>item.parentId==parentId);
						if(result1!=-1){
							this.choosedNode.push(node);
						}else{
							this.choosedNode=[];
							choosedNodeNow=[];
							this.choosedNode.push(node);
							choosedNodeNow.push(node.id);
						}
					}else{
						this.choosedNode.splice(result,1);
					}
					choosedNodeNow.map(item=>{
						this.$refs.nodeTree.setChecked(item,true)
					})
					let resultM=this.choosedNode.map(item=>{
						return item.name
					})
					// this.$refs.nodeTree.setCheckedKeys(choosedNodeNow);
					this.$emit('nodeCheck', {ids:choosedNodeNow,names:resultM})
				}
				
			}
		}
	}
</script>

<style lang="less" scoped>
	.plug-tree {
		width: 260px;
		height: 100%;
		.topCut {
			display: flex;
			padding: 5px;
			flex-direction: row;
			justify-content: space-between;
			height: 30px;
			background: #e3f7fc;
			color: #666;
			line-height: 30px;
			text-align: center;
			font-size: 14px;
			.title{
				width: 100%;
				text-align: center;
				display: inline-block;
			}
		}
	}
</style>
